var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLower0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 16",
    className: "w-[12px] rotate-180",
    fill: "#2AB2E9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4864 13.667C3.92507 13.667 3.4701 13.3014 3.4701 12.8494L3.47099 7.54931L1.18095 7.54931C0.306767 7.54931 -0.251889 6.81602 0.113696 6.19768L0.160176 6.127L3.9787 0.807585C4.43188 0.175683 5.56796 0.175683 6.02204 0.807585L9.84056 6.127C10.2937 6.7589 9.72704 7.54931 8.81889 7.54931L6.52974 7.54931L6.52974 12.8494C6.52974 13.3014 6.07477 13.667 5.51344 13.667L4.48819 13.667L4.4864 13.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLower0);
export default __webpack_public_path__ + "static/media/lower0.7b8ef36489bee82be89f3f2338a04107.svg";
export { ForwardRef as ReactComponent };